import {Types} from 'mongoose';
import {STATE as items} from './state.const';

export const STATE = {
    type: 'State',
    category: 'System',
    value: items.map(item => ({...item, _id: new Types.ObjectId(item._id)})),
};
